import ConfigurationPageContainer from "./components/configuration-page-container";

export default ConfigurationPageContainer;